
import { environment } from "src/environments/environment";
import { Router } from '@angular/router';
import { Component, OnInit, PLATFORM_ID, Inject } from "@angular/core";
import { isPlatformBrowser } from '@angular/common';
import { FormBuilder, Validators } from "@angular/forms";
import { AppService } from "../app.service";

declare const $;
declare var google: any;
declare var gtag;
declare var fbq;

@Component({
  selector: "app-quicklisting",
  templateUrl: "./quicklisting.component.html",
  styleUrls: ["./quicklisting.component.css"],
})
export class QuicklistingComponent implements OnInit {

  public postingLoader: boolean = false;
  public quickpostingValid: boolean = false;
  otpVerifymsg: string = "";
  otpVerifyLoader: boolean = false; 
  public options: any;
  public alwarBounds: any;
  showMsg: string = '';
  public thankuMsg: string = "";
  thankyouForm: boolean = false;
  cityList:any=[];
  keyword = 'name';
  selectCityId:any;
  cityName:any;
  interval:any;
  public otpTimeLimit=30;
  propertyDetails:boolean = true;
  AdditionalDetails:boolean = false;
  sendOtpButton:boolean = true;
  resendOtpButton:boolean = false;
  firstPropertyFormValid:boolean = false;
  isChecked:boolean = true;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private service: AppService, private fb: FormBuilder, private router: Router) { }

  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("Completequicklisting", "quicklisting", "QuickListing");

    fbq('track', "CompleteQuickListing" , {
      content_type: "quicklisting",
      content_title: this.router.url,
    });
  }


    
    if (isPlatformBrowser(this.platformId)) {

      this.alwarBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(environment.norteastLatLongFirst, environment.norteastLatLongSecond),
        new google.maps.LatLng(environment.southwestLatLongFirst, environment.southwestLatLongSecond)
      );

      this.options = {
        bounds: this.alwarBounds,
        radius: 15,
        componentRestrictions: { country: "IN" },
        strictBounds: environment.strictBounds,
      };
    }

    this.firstPropertydetails.get("property_type").valueChanges.subscribe((val) => {

      // (<HTMLInputElement>document.getElementById("form-location")).value = "";
      // this.imageArray = [];
      // this.fileSource = [];
      // this.quickposting.get("images").reset();
      // this.quickposting.get("file").reset();
      // this.quickposting.get("price").reset();
      // this.quickposting.get("words").reset();
      if (val == "3") {
        this.firstPropertydetails.patchValue({
          looking_type: "0",
          looking_subcat_type: "0",
          looking_subcat_type_value: "0",
          available_category: "",
          gender: "",
          room_type: "",
          food_option: "",
        });
      } else {
        this.firstPropertydetails.patchValue({
          looking_type: "",
          looking_subcat_type: "",
          looking_subcat_type_value: "",
          available_category: "0",
          gender: "0",
          room_type: "0",
          food_option: "0",
          food_type:"0"
        });
      }
    });

    this.firstPropertydetails.get("looking_type").valueChanges.subscribe((val) => {
      this.quickposting.patchValue({ looking_subcat_type: "" });
      (<HTMLInputElement>document.getElementById("form-location")).value = "";
      this.imageArray = [];
      this.fileSource = [];
      this.quickposting.get("file").reset();
      this.quickposting.get("images").reset();
      this.quickposting.get("price").reset();
      this.quickposting.get("words").reset();
    });

    this.firstPropertydetails
      .get("looking_subcat_type")
      .valueChanges.subscribe((val) => {
        (<HTMLInputElement>document.getElementById("form-location")).value = "";
        this.imageArray = [];
        this.fileSource = [];
        this.quickposting.get("file").reset();
        this.quickposting.get("images").reset();
        this.quickposting.get("price").reset();
        this.quickposting.get("words").reset();
        const data = this.quickposting.get("property_type").value;
        const areaunit = this.quickposting.get("area_unit");
        const superareaunit = this.quickposting.get("superarea_unit");
        const floortorent = this.quickposting.get("floor_torent");
        const constructedfloor = this.quickposting.get("constructed_floor");

        if (val == "8" || val == "9" || val == "13") {
          this.quickposting.patchValue({ looking_subcat_type_value: "0" });
        } else {
          this.quickposting.patchValue({ looking_subcat_type_value: "" });
        }

        if (
          (data == "1" &&
            (val == "1" || val == "5" ||
              val == "6" ||
              val == "7" ||
              val == "9" ||
              val == "10" ||
              val == "13")) ||
          (data == "2" &&
            (val == "2" ||
              val == "4" ||
              val == "7" ||
              val == "8" ||
              val == "9" ||
              val == "10" ||
              val == "13"))
        ) {
          this.quickposting.patchValue({
            area: "",
          });
        } else {
          this.quickposting.patchValue({
            area: "0",
          });
        }

        var res = this.quickposting.get("whichpart_torent").value;
        if ((data == "2" && (val == "2" || val == "4" || val == "7" || val == "8" || val == "9" || val == "10" || val == "13")) || (data == "1" && (val == "1" || val == "5" || val == "6" || val == "7" || val == "9" || val == "10" || val == "13"))) {
          this.quickposting.patchValue({
            area_unit: "",
          });
          if ((data == "1" && (val == "9")) || (data == "2" && (val == "2" || val == "9"))) {
            this.quickposting.patchValue({
              constructed_floor: "",
            });
            constructedfloor.setValidators([Validators.required]);
          } else {
            constructedfloor.clearValidators();
          }
          areaunit.setValidators([Validators.required]);
          superareaunit.clearValidators();
        } else {
          areaunit.clearValidators();
          constructedfloor.clearValidators();
        }

        if (
          (data == "2" && (val == "1" || val == "5" || val == "6"))
        ) {
          this.quickposting.patchValue({
            super_area: "",
          });
        } else {
          this.quickposting.patchValue({
            super_area: "0",
          });
        }

        if (
          (data == "2" && (val == "1" || val == "5" || val == "6"))
        ) {
          this.quickposting.patchValue({
            superarea_unit: "",
          });
          areaunit.clearValidators();
          superareaunit.setValidators([Validators.required]);
          constructedfloor.clearValidators();
        } else {
          superareaunit.clearValidators();

        }
        
        if (
          (data == "1" && (val == "7" || val == "10")) ||
          (data == "2" &&
            (val == "4" || val == "7" || val == "10" || val == "13"))
        ) {
          this.quickposting.patchValue({
            width_of_facing_road: "",
          });
        } else {
          this.quickposting.patchValue({
            width_of_facing_road: "0",
          });
        }

        if (
          (data == "1" && val == "2") ||
          (data == "2" && (val == "2" || val == "4" || val == "7"))
        ) {
          this.quickposting.patchValue({
            facing: "",
          });
        } else {
          this.quickposting.patchValue({
            facing: "0",
          });
        }

        if (
          (data == "1" && (val == "10" || val == "13")) ||
          (data == "2" && val == "13")
        ) {
          this.quickposting.patchValue({
            shade: "",
          });
        } else {
          this.quickposting.patchValue({
            shade: "0",
          });
        }

        if (data == "1" && val == "2") {
          this.quickposting.patchValue({
            kitchen: "",
          });
        } else {
          this.quickposting.patchValue({
            kitchen: "0",
          });
        }

        if (data == "1" && (val == "5" || val == "6")) {
          this.quickposting.patchValue({
            noof_floors: "",
          });
        } else {
          this.quickposting.patchValue({
            noof_floors: "0",
          });
        }

        if (data == "1" && (val == "5" || val == "6")) {
          this.quickposting.patchValue({
            whichpart_torent: "",
          });
        } else {
          this.quickposting.patchValue({
            whichpart_torent: "0",
          });
        }

        if (data == "1" && val == "13") {
          this.quickposting.patchValue({
            office: "",
          });
        } else {
          this.quickposting.patchValue({
            office: "0",
          });
        }

        if (data == "1" && (val == "1" || val == "2" || val == "9")) {
          this.quickposting.patchValue({
            baathroom: "",
          });
        } else {
          this.quickposting.patchValue({
            baathroom: "0",
          });
        }

        if (
          (data == "2" &&
            (val == "5" || val == "6" || val == "10" || val == "13"))
        ) {
          this.quickposting.patchValue({
            ownership_by: "",
          });
        } else {
          this.quickposting.patchValue({
            ownership_by: "0",
          });
        }

        if (data == "2" && (val == "5" || val == "6")) {
          this.quickposting.patchValue({
            carpet_area: "",
          });
        } else {
          this.quickposting.patchValue({
            carpet_area: "0",
          });
        }

        if (data == "2" && (val == "5" || val == "6")) {
          this.quickposting.patchValue({
            carpetarea_unit: "2",
          });
        } else {
          this.quickposting.patchValue({
            carpetarea_unit: "0",
          });
        }

        if (
          (data == "1" && (val == "9" || val == "13")) ||
          (data == "2" && val == "9")
        ) {
          if (val == "2" || val == "9" || val == "13") {
            this.quickposting.patchValue({
              no_of_rooms: "",
            });
          }
        } else {
          this.quickposting.patchValue({
            no_of_rooms: "0",
          });
        }
      });

    this.quickposting.get("food_option").valueChanges.subscribe((val) => {
      if (val == "1") {
        this.quickposting.patchValue({ food_type: "" });
      } else {
        this.quickposting.patchValue({ food_type: "0" });
      }
    });

    this.quickposting
      .get("looking_subcat_type_value")
      .valueChanges.subscribe((val) => {
        const data = this.quickposting.get("property_type").value;
        if (val == "4" || (data == "1" && (val == "7" || val == "8"))) {
          this.quickposting.patchValue({ no_of_rooms: "" });
        } else {
          this.quickposting.patchValue({ no_of_rooms: "0" });
        }

        if (val == "2" || val == "3" || val == "5" || val == "6") {
          this.quickposting.patchValue({ no_of_bhk: "" });
        } else {
          this.quickposting.patchValue({ no_of_bhk: "0" });
        }

      });
    const floortorent = this.quickposting.get("floor_torent");
    this.quickposting.get("whichpart_torent").valueChanges.subscribe((val) => {
      if (val == "2") {
        this.quickposting.patchValue({ floor_torent: "" });
        floortorent.setValidators([Validators.required]);
      } else {
        floortorent.clearValidators();
      }

    });
     

    if (this.service.isLoggedIn()) {
      var userDetail = JSON.parse(localStorage.getItem("currentUser"));
      this.quickposting.patchValue({
        email_id: userDetail.email,
        mobile: userDetail.mobile,
        you_are: userDetail.user_type,
        name: userDetail.name,
      });
    }

    this.service.post('/getCityNameByState',{state_id:33}).subscribe((data:any)=>{
      if(data[0].error == 0){
        this.cityList=data[0].result;
        console.log(this.cityList);
      }
    });

    if (this.service.isLoggedIn()) {
      var userDetail = JSON.parse(localStorage.getItem("currentUser"));
      this.firstPropertydetails.patchValue({
        email_id: userDetail.email,
        mobile: userDetail.mobile,
        you_are: userDetail.user_type,
        name: userDetail.name,
        otp:'000'
      });
    }

  }

  get isUserLogin(){ return this.service.isLoggedIn() }

  CityInputFocused(){
    $("#like").show();
  }

  getSelectedCity(event:any){

    if(event != ""){
      $("#like").hide();
    }
    this.cityName=event.name;

    this.selectCityId = event.id;
    this.quickposting.controls['city_id'].setValue(this.selectCityId);
  }

  fileSource: string[] = [];

  firstPropertydetails = this.fb.group({
    property_type: ['',[Validators.required]],
    looking_type:['',[Validators.required]],
    looking_subcat_type:['',[Validators.required]],
    name:['',[Validators.required,Validators.pattern("")]],
    email_id:['',Validators.email],
    mobile:['',[Validators.required,Validators.pattern(/^[6-9]\d{9}$/)]],
    you_are: ["", Validators.required],
    otp: ["", Validators.required],
    looking_subcat_type_value:[""]
  })

  get firstPropertyControl() {
    return this.firstPropertydetails.controls;
  }


  quickposting = this.fb.group({
    property_type: ['',[Validators.required]],
    looking_type:['',[Validators.required]],
    looking_subcat_type:['',[Validators.required]],
    available_category: ['',[Validators.required]],
    gender:['',[Validators.required]],
    room_type:['',[Validators.required]],
    food_option:['',[Validators.required]],
    food_type:['',[Validators.required]],
    looking_subcat_type_value:['',[Validators.required]],
    location: ["", [Validators.required]],
    location_lat: [""],
    location_long: [""],
    sublocality_address: [""],
    price: ["", [Validators.required]],
    words: "",
    super_area: ["", [Validators.required]],
    superarea_unit: [""],
    area: ["", [Validators.required]],
    area_unit: [""],
    carpet_area: ["", [Validators.required]],
    carpetarea_unit: ["2"],
    file: "",
    images: "",
    boundary: [false],
    shade: ["", [Validators.required]],
    no_of_rooms: ["", [Validators.required]],
    no_of_bhk: ["", [Validators.required]],
    baathroom: ["", [Validators.required]],
    kitchen: ["", [Validators.required]],
    office: ["", [Validators.required]],
    constructed_floor: [""],
    noof_floors: ["", [Validators.required]],
    whichpart_torent: ["", [Validators.required]],
    floor_torent: [""],
    ownership_by: ["", [Validators.required]],
    facing: ["", [Validators.required]],
    width_of_facing_road: ["", [Validators.required]],
    city_id:["",[Validators.required]],
    slug:['']
  });

  get quickpostingControl() {
    return this.quickposting.controls;
  }

  handleAddressChange(event, type = "") {
    console.log(event);
    if (type == 'mannual' && event.target.value == '') {
      this.quickposting.patchValue({
        location_lat: '',
        location_long: '',
        location: '',
        sublocality_address: '',
      });
    } else if (type == 'address') {
      this.quickposting.patchValue({
        location_lat: event.geometry.location.lat(),
        location_long: event.geometry.location.lng(),
        sublocality_address: event.name,
      });
      let locat = (<HTMLInputElement>document.getElementById("form-location")).value;
      this.quickposting.patchValue({ location: locat });
      console.log(this.quickposting);
    }

  }

  get chkCarpetSuperArea() {
    if (
      parseFloat(this.quickposting.value.super_area) > 0 &&
      parseFloat(this.quickposting.value.carpet_area) > 0
    ) {
      if (
        parseFloat(this.quickposting.value.super_area) >
        parseFloat(this.quickposting.value.carpet_area)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  propertySubmit() {
    console.log(this.quickposting);
    this.quickpostingValid = false;
    this.showMsg = '';
    if (this.imageArray.length == 0) {
      this.quickposting.get("file").reset();
    }
    // if (this.quickposting.valid) { 
    // } else {
    //   this.quickpostingValid = true;
    // }
    this.propertySubmitData(); 

  }
  propertyLoader: boolean = false;
  propertySubmitData() {

      this.propertyLoader = true;

      this.postingLoader = true;
      const propertyData = new FormData();
      this.imageArray = [];
      propertyData.append("type", "Web");
      propertyData.append("auth_token", this.service.getAuthorizationToken());
      let imagesLength = this.quickposting.get("images").value;
      for (var j = 0; j < imagesLength.length; j++) {
        propertyData.append("images[]", imagesLength[j], imagesLength[j].name);
      }
  
      this.service
        .postMultipart("/uploadPropertyImage", propertyData)
        .subscribe((imagesdata) => {
          console.log(imagesdata);
          if (imagesdata[0].error == "0" && imagesdata[0].images != "") {
            // data['images']=imagesdata[0].images;
            this.quickposting.patchValue({ images: imagesdata[0].images });
            if (this.quickposting.get("boundary").value) {
              this.quickposting.patchValue({ boundary: true })
            } else {
              this.quickposting.patchValue({ boundary: "0" })
            }
            
            this.service
              .post("/addQuickProperty", this.quickposting.value)
              .subscribe(
                (data: any) => {
                  console.log(data);
                  if (!data[0].error) {
                    // this.service.messageBox("success", data[0].msg);
                     //set google analytics
                    if (environment.production) {
                      this.googleFacbookAnyalytics(this.quickposting.value.property_type,this.quickposting.value.looking_type,"SubmitApplication",data[0].id,this.quickposting.value.price,this.quickposting.value.location);
                    }
                    this.propertyLoader = false;
                    this.thankyouForm = true;
                    this.thankuMsg = data[0].msg;
                     
                    this.quickposting.reset();
                    this.quickposting.patchValue({
                      area_unit: "",
                      superarea_unit: "",
                      floor_torent: "",
                      constructed_floor: "",
                    });
                    (<HTMLInputElement>document.getElementById("form-location")).value = "";
                    if (this.service.isLoggedIn()) {
                      var userDetail = JSON.parse(
                        localStorage.getItem("currentUser")
                      );
                      this.quickposting.patchValue({
                        email_id: userDetail.email,
                        mobile: userDetail.mobile,
                        you_are: userDetail.user_type,
                        name: userDetail.name,
                      });
                    }
                    $(".otptext").val("");
                    this.fileSource = [];
                  

                  } else {
                    this.service.messageBox("failed", data[0].msg);
                  }

                  this.postingLoader = false;
                },
                (error: any) => {
                  this.service.messageBox("failed", error.errorDesc);
                  this.postingLoader = false;
                }
              );
          } else {
            this.quickpostingValid = true;
            this.postingLoader = false;
            this.service.messageBox("failed", imagesdata[0].msg);
          }
        });
      window.scroll(0, 0);

  }

  googleFacbookAnyalytics(property_type:any,looking_type:any,action,propertyID,property_price,property_location){

    var lookingType;
  if(looking_type == "1"){
    lookingType = "Residential"
  }else if(looking_type == "2"){
    lookingType = "Commercial"
  }else if(looking_type == "3"){
    lookingType = "Agriculture"
  }else if(looking_type == "4"){
    lookingType = "Industrial"
  }

  gtag('config', environment.gtagId, {
    'page_path': 'https://www.propira.com/quick-listing/thankyou'
  });
  if(property_type == "1"){
    this.service.sendEvents(
      "Rent",
      lookingType,
      action
    );
   this.triggerfacebookAnalytics(action,lookingType,propertyID,property_price,property_location)
  }else if(property_type == "2"){
    this.service.sendEvents(
      "Buy",
      lookingType,
      action
    );
    this.triggerfacebookAnalytics(action,lookingType,propertyID,property_price,property_location)
  }else if(property_type == "3"){
    this.service.sendEvents(
      "Pg",
      lookingType,
      action
    );
    this.triggerfacebookAnalytics(action,lookingType,propertyID,property_price,property_location)
  }
}

triggerfacebookAnalytics(eventCategory,lookingType,propertyID,property_price,property_location){
  const ID = [this.cityName,propertyID]

fbq(
  'init', environment.fbId, {
  'track': 'https://www.propira.com/quick-listing/thankyou'
}
);
fbq('track', eventCategory , {
  content_category:eventCategory,
  content_ids:ID,
  content_type: lookingType,
  content_property_price:property_price,
  content_property_location:property_location,
  content_event_action: "Upload",
  content_event_label: "New Property"
});

}

  sendOtp(type = "") {
    this.otpVerifymsg = "";
    if (type == "resend") {
      this.otpVerifyLoader = true;
      this.resendOtpTime=this.otpTimeLimit;
       this.strartOtpInterval();
    }

    var userType;

    if (this.service.isLoggedIn()) {
      userType = "old";
    } else {
      userType = "any";
    }

    this.service
      .post("/sendOtpforAnyMobile", {
        mobile: this.firstPropertydetails.value.mobile,
        user_type: userType,
      })
      .subscribe(
        (data) => {
          if (data[0].error == "1") {
            this.service.messageBox("failed", data[0].msg);
          } else {
            if (type == "") {

              this.sendOtpButton = false;
              this.resendOtpButton = true;
              this.resendOtpTime=this.otpTimeLimit;
              this.strartOtpInterval();

              this.otpVerifymsg = this.service.successMsg(data[0].msg);
            } else {
              this.otpVerifymsg = this.service.successMsg(data[0].msg);
            }
          }
          this.otpVerifyLoader = false;
        },
        (error) => {
          this.service.messageBox("failed", error.errorDesc);
        }
      );
  }

  resendOtpTime=this.otpTimeLimit;

  strartOtpInterval(){
    this.interval = setInterval(() => {
      if(this.resendOtpTime>0){
        this.resendOtpTime--;
      }else{
        clearInterval(this.interval);
      }
    }, 1000);
  }

  ngOnDestroy(){
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  otpVerify() {

    var loginUserDetail = JSON.parse(localStorage.getItem('currentUser'));

    if(this.service.isLoggedIn()){
      this.firstPropertydetails.patchValue({"you_are":loginUserDetail.user_type,"otp":"000","mobile":loginUserDetail.mobile,"email_id":loginUserDetail.email,"name":loginUserDetail.name})
    }

    this.firstPropertyFormValid = false;
    
    if(this.firstPropertydetails.valid){

      var otp=this.firstPropertydetails.value.otp;

      this.otpVerifyLoader = true;
      this.service
        .post("/otpVerifyForQuickPropertyPosting", {
          mobile: this.firstPropertydetails.value.mobile,
          otp: otp,
          you_are: this.firstPropertydetails.value.you_are,
          name:this.firstPropertydetails.value.name,
          email_id:this.firstPropertydetails.value.email_id,
          property_type:this.firstPropertydetails.value.property_type,
          looking_type:this.firstPropertydetails.value.looking_type,
          looking_subcat_type:this.firstPropertydetails.value.looking_subcat_type,
          looking_subcat_type_value:this.firstPropertydetails.value.looking_subcat_type_value
        })
        .subscribe(
          (data) => {
            if (data[0].error == "1") {
              this.service.messageBox('failed',data[0].msg);
            } else {
              if(!this.service.isLoggedIn()){
                this.service.chkLogin(data[0].mobile,data[0].otp,'no');
              }
              console.warn(this.firstPropertydetails.value);
              this.quickposting.patchValue({'slug':data[0].slug});
              this.quickposting.patchValue({'property_type':this.firstPropertydetails.value.property_type});
              this.quickposting.patchValue({'looking_type':this.firstPropertydetails.value.looking_type});
              this.quickposting.patchValue({'looking_subcat_type':this.firstPropertydetails.value.looking_subcat_type});
              this.quickposting.patchValue({'looking_subcat_type_value':this.firstPropertydetails.value.looking_subcat_type_value});
              this.propertyDetails = false;
              this.AdditionalDetails = true;
            }
            this.otpVerifyLoader = false;
          },
          (error) => {
            this.service.messageBox('failed',error.errorDesc);
            this.otpVerifyLoader = false;
          }
        );

    }else{
      this.firstPropertyFormValid = true;
    }
    
  }

  numberOnly(event, length = 0, pointAllow = 0): boolean {
    const iKeyCode = event.which ? event.which : event.keyCode;
    if (
      (pointAllow == 1 &&
        iKeyCode != 46 &&
        iKeyCode > 31 &&
        (iKeyCode < 48 || iKeyCode > 57)) ||
      (pointAllow == 0 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
    ) {
      return false;
    } else if (length > 0) {
      var valueLength = event.target.value.length;
      if (valueLength >= length) {
        return false;
      }
    } else {
      return true;
    }
  }

  imageErrorMsg: string = "";
  imageArray: string[] = [];

  onSelectPropertyImage(event) {
    var totalPropertyImageLength = this.fileSource.length;
    this.imageErrorMsg = "";
    if (event.target.files.length + totalPropertyImageLength > 10) {
      this.imageErrorMsg = "You can upload max 10 images only";
    } else {
      if (event.target.files && event.target.files[0]) {
        var files = event.target.files;
        var filesAmount = event.target.files.length;
        for (let i = 0; i < filesAmount; i++) {
          if (files[i].size > 524288000000000000000000000000000000000000000000000000000000000000000000000000000000000000) {
            this.imageErrorMsg = "Image size must be less than 5 MB";
          } else if (!files[i].name.match(/.(jpg|jpeg|png|gif)$/i)) {
            this.imageErrorMsg = "Invalid image found in selected image";
          } else {
            var reader = new FileReader();
            this.imageArray.push(files[i]);
            reader.onload = (event: any) => {
              console.log(event.target.result);
              console.log(files[i]);
              this.fileSource.push(event.target.result);
              console.log(this.fileSource);
            };
            reader.readAsDataURL(files[i]);
          }
        }
        this.quickposting.patchValue({ images: this.imageArray });
        console.log(this.quickposting);
      }
    }
  }
  getWords() {
    if (this.quickposting.get("price").value > 0) {
      this.quickposting.patchValue({
        words:
          "INR " +
          this.service.convert_number(this.quickposting.get("price").value) +
          " Only",
      });
    } else {
      this.quickposting.patchValue({
        words:
          "INR " +
          this.service.convert_number(this.quickposting.get("price").value) +
          " Only",
      });
    }
  }

  deleteImage(imageId: any) {
    var array = this.imageArray;
    var imagePreviewUrl = this.fileSource;
    this.fileSource = [];
    this.imageArray = [];
    this.quickposting.get("images").reset();
    if (array.length > 0) {
      for (var i = 0; i < array.length; i++) {
        if (i != imageId) {
          this.fileSource.push(imagePreviewUrl[i]);
          this.imageArray.push(array[i]);
          this.quickposting.patchValue({ images: this.imageArray });
        }
      }
    }
  }

  openBasicInfoForm() {
    this.thankyouForm = false;
    this.propertyDetails = true;
    this.AdditionalDetails = false;
    this.firstPropertydetails.reset();
    this.quickposting.reset();
  }

  whichFloorlist: any = []
  getValueOfWhichFloorNo() {
    this.whichFloorlist = [];
    var number = parseInt(this.quickposting.get("noof_floors").value);
    for (var i = 1; i <= number; i++) {
      if (i == 40) {
        this.whichFloorlist.push('40+');
      } else {
        this.whichFloorlist.push(i);
      }
    }
  }
}
